document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('#MobileMenu');
  if (toggle && menu) toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu.hidden = open;
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantsNode = section.querySelector('[data-variants]');
    const select = section.querySelector('.variant-select');
    const price = section.querySelector('[data-price]');
    const button = section.querySelector('.add-button');
    if (!variantsNode || !select) return;
    const variants = JSON.parse(variantsNode.textContent);
    const radios = [...section.querySelectorAll('.variant-fieldset input[type="radio"]')];
    const update = () => {
      const groups = [...section.querySelectorAll('.variant-fieldset')];
      const values = groups.map((group) => {
        const selected = group.querySelector('input:checked')?.value;
        const label = group.querySelector('[data-selected-option]');
        if (label && selected) label.textContent = selected;
        return selected;
      });
      const variant = variants.find((item) => item.options.every((value, index) => value === values[index]));
      if (!variant) return;
      select.value = String(variant.id);
      const option = select.selectedOptions[0];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (button) { button.disabled = !variant.available; button.textContent = variant.available ? 'Add to bag' : 'Sold out'; }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    radios.forEach((radio) => radio.addEventListener('change', update));
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const syncOutfitBuilderMode = () => document.body.classList.toggle('outfit-builder-mode', window.location.hash === '#outfit-builder');
  syncOutfitBuilderMode();
  window.addEventListener('hashchange', syncOutfitBuilderMode);
  document.querySelectorAll('[data-outfit-builder]').forEach((builder) => {
    const read = (kind) => { const node = builder.querySelector(`[data-outfit-products="${kind}"]`); return node ? JSON.parse(node.textContent) : []; };
    const products = { top: read('top'), bottom: read('bottom') };
    if (!products.top.length || !products.bottom.length) return;
    const productSelects = { top: builder.querySelector('[data-outfit-select="top"]'), bottom: builder.querySelector('[data-outfit-select="bottom"]') };
    const variantSelects = { top: builder.querySelector('[data-outfit-variant="top"]'), bottom: builder.querySelector('[data-outfit-variant="bottom"]') };
    const money = (cents) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: window.Shopify?.currency?.active || 'INR', maximumFractionDigits: 0 }).format(cents / 100);
    const selectedProduct = (kind) => products[kind][Number(productSelects[kind].value) || 0];
    const selectedVariant = (kind) => selectedProduct(kind)?.variants.find((variant) => String(variant.id) === variantSelects[kind].value);
    const updateTotal = () => {
      const selected = [selectedVariant('top'), selectedVariant('bottom')];
      const builderTotal = selected.reduce((sum, variant) => sum + (variant?.price || 0), 0);
      const regular = selected.reduce((sum, variant) => sum + Math.max(variant?.compare_at_price || 0, variant?.price || 0), 0);
      builder.querySelector('[data-outfit-regular-total]').textContent = money(regular);
      builder.querySelector('[data-outfit-total]').textContent = money(builderTotal);
      const saving = Math.max(0, regular - builderTotal);
      builder.querySelector('[data-outfit-saving]').textContent = saving ? `You save ${money(saving)} on this outfit.` : 'Set a higher Compare-at price on the Builder products to show the saving.';
    };
    const renderProduct = (kind) => {
      const product = selectedProduct(kind); const variant = product.variants.find((item) => item.available) || product.variants[0];
      const image = builder.querySelector(`[data-outfit-image="${kind}"]`); image.src = product.image || ''; image.alt = product.title;
      builder.querySelector(`[data-outfit-title="${kind}"]`).textContent = product.title;
      variantSelects[kind].innerHTML = product.variants.map((item) => `<option value="${item.id}" ${item.available ? '' : 'disabled'}>${item.title}${item.available ? '' : ' — Sold out'}</option>`).join('');
      variantSelects[kind].value = String(variant.id); updateTotal();
    };
    ['top', 'bottom'].forEach((kind) => {
      productSelects[kind].innerHTML = products[kind].map((product, index) => `<option value="${index}">${product.title}</option>`).join('');
      productSelects[kind].addEventListener('change', () => renderProduct(kind)); variantSelects[kind].addEventListener('change', updateTotal); renderProduct(kind);
    });
    builder.querySelector('[data-outfit-refresh]').addEventListener('click', () => {
      ['top', 'bottom'].forEach((kind) => { productSelects[kind].value = String(Math.floor(Math.random() * products[kind].length)); renderProduct(kind); });
      builder.querySelector('[data-outfit-message]').textContent = 'A fresh outfit combination is ready.';
    });
    builder.querySelector('[data-outfit-recommend]').addEventListener('click', () => {
      const topTags = new Set((selectedProduct('top').tags || []).map((tag) => tag.toLowerCase())); let bestIndex = 0; let bestScore = -1;
      products.bottom.forEach((product, index) => { const score = (product.tags || []).reduce((sum, tag) => sum + (topTags.has(tag.toLowerCase()) ? 1 : 0), 0); if (score > bestScore || (score === bestScore && Math.random() > .5)) { bestIndex = index; bestScore = score; } });
      productSelects.bottom.value = String(bestIndex); renderProduct('bottom'); builder.querySelector('[data-outfit-message]').textContent = 'A matching Kayko outfit is ready.';
    });
    builder.querySelector('[data-outfit-add]').addEventListener('click', async (event) => {
      const button = event.currentTarget; const variants = [selectedVariant('top'), selectedVariant('bottom')]; if (variants.some((variant) => !variant?.available)) return;
      button.disabled = true; button.textContent = 'Adding outfit…';
      try { const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: variants.map((variant) => ({ id: variant.id, quantity: 1, properties: { '_Kayko outfit': 'Yes' } })) }) }); if (!response.ok) throw new Error('Cart error'); window.location.href = '/cart'; }
      catch (error) { builder.querySelector('[data-outfit-message]').textContent = 'This outfit could not be added. Please check the selected sizes.'; button.disabled = false; button.textContent = 'Add discounted outfit to bag'; }
    });
  });

  document.querySelectorAll('[data-coupon-checkout]').forEach((button) => {
    button.addEventListener('click', (event) => {
      const input = button.closest('form')?.querySelector('[data-coupon-code]');
      const code = input?.value.trim();
      if (!code) return;
      event.preventDefault();
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/checkout')}`;
    });
  });
});
